import React from "react";
import TestChoices from "./AnswerEditExam.jsx";
import TestChoicesMultiple from "./AnswerEditExamMultiple.jsx";
import TestChoicesMenjodohkan from "./AnswerEditMenjodohkan.jsx";
import TestShortAnswer from "./AnswerShortEditExam.jsx";
import TestChoicesTrueFalse from "./AnswerEditChoicesTrueFalse";
import { connect } from "react-redux";
import { inputQuestion, inputVideoEmbed, addQuestion, addQuestionEssay, addQuestionTrueFalse, addQuestionMenjodohkan, deleteQuestion, removeImage, addToListImg, addImageQues, addImageFileQues, inputKdUnit } from "../../../store/actions/index";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import ImageIcon from "@material-ui/icons/Image";
import ImageUploader from "react-images-upload";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import axiosInstance from "../../../store/services/AxiosService";
import imageCompression from "browser-image-compression";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { config1 } from "../component/ConfigEditor";
import Ball from "../../../assets/Ball.svg";
import { withRouter } from "react-router-dom";

const baseImgURL = process.env.REACT_APP_BACKEND_IMAGES2;
class Question extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            kdUnit: null,
            kdDescription: null,
            kompetensiDasarOptions: [],
            unitDetailsOptions: null,
            savedKdUnits: [],
            isLoadingKD: true,
        };
    }

    getIndex = (key, stateData) => {
        var index = stateData
            .map(function (item) {
                return item.key;
            })
            .indexOf(key);
        return index;
    };

    convertToEmbedUrl(url) {
        if (!url) return '';
        // YouTube: watch?v=, youtu.be/, embed/
        const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/);
        if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
        // Already an embed URL
        if (url.includes('/embed/') || url.includes('/embed?')) return url;
        // Google Drive video
        const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
        if (driveMatch) return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
        return url;
    }

    handleUpdateQuestion = (keyPart, keyQues, data, text) => {
        var indexQues = this.getIndex(keyQues, data);
        this.props.inputQuestion(keyPart, indexQues, text);
    };

    handleUpdateVideoEmbed = (keyPart, keyQues, data, text) => {
        var indexQues = this.getIndex(keyQues, data);
        this.props.inputVideoEmbed(keyPart, indexQues, text);
    };

    handleIconAddImg = (indexPart, indexQues) => {
        this.props.addImageQues(indexPart, indexQues, null);
    };

    async handleUploadImg(e, indexPart, indexQues, oldFile, fileNew) {
        e.preventDefault();
        if (fileNew !== null || fileNew !== undefined) {
            this.props.addImageQues(indexPart, indexQues, "Loading");
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 720,
                useWebWorker: true,
            };
            this.props.addToListImg(oldFile);
            const compressedFile = await imageCompression(fileNew, options);
            var imgCompressed = new File([compressedFile], "uploaded_file.jpg", {
                type: "image/jpeg",
                lastModified: Date.now(),
            });
            let data = new FormData();
            data.append("file_attached", imgCompressed);
            data.append("old_file", null);
            const url = "/files/upload";
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };
            axiosInstance
                .post(url, data, config)
                .then((r) => {
                    this.props.addImageQues(indexPart, indexQues, r.data.file);
                    this.props.addImageFileQues(indexPart, indexQues, null);
                    this.props.addToListImg(r.data.file);
                    this.setState({ statusUpload: true });
                })
                .catch((error) => {
                    alert(`Proses upload gagal`);
                });
        }
    }

    async handleDeleteImage(e, fileName, indexPart, indexQues) {
        e.preventDefault();
        if (fileName !== null) {
            const data = { file_name: fileName };
            const url = "/files/delete";
            axiosInstance
                .post(url, data)
                .then((r) => {
                    this.props.removeImage(indexPart, indexQues);
                })
                .catch((error) => {
                    alert(`Proses delete gagal => ${error.message}`);
                });
        } else {
            this.props.removeImage(indexPart, indexQues);
        }
    }

    handleResetQuestion(case_question_id) {
        if (case_question_id == null) return
        this.setState((prevState) => {
            const newUnitDetailsOptions = { ...prevState.unitDetailsOptions };
            delete newUnitDetailsOptions[case_question_id];
            return {
                savedKdUnits: {
                    ...prevState.savedKdUnits,
                    [case_question_id]: { api_kd_id: null, api_unit_id: null, description: null },
                },
                unitDetailsOptions: newUnitDetailsOptions,
            };
        });
    }

    onDrop(pictureFiles, pictureDataURLs, indexPart, indexQues) {
        this.props.addImageFileQues(indexPart, indexQues, pictureFiles[0]);
    }

    show() {
        this.setState({ hidden: false });
    }

    fetchKdUnit(idCourse, idClass, idSchool) {
        if (!idClass || !idCourse || !idSchool || idClass === 'null' || idClass === 'undefined') return;
        if (this.state.isLoadingKD) return; // Prevent loop / duplicate calls while in flight
        this.setState({ isLoadingKD: true });
        const url = `/kompetensi-dasar/course/${idCourse}/class/${idClass}/school/${idSchool}`;
        axiosInstance
            .get(url)
            .then((r) => {
                const data = r.data || [];
                this.setState({ kdUnit: data, isLoadingKD: false });
                this.initializeKompetensiDasar(data);
            })
            .catch((error) => {
                console.warn(`Proses fetch KD gagal => ${error.message}`);
                this.setState({ isLoadingKD: false, kdUnit: [] });
            });
    }

    componentDidMount() {
        if (this.props.listKd && Array.isArray(this.props.listKd) && this.props.listKd.length > 0) {
            this.setState({ kdUnit: this.props.listKd, isLoadingKD: false });
            this.initializeKompetensiDasar(this.props.listKd);
        } else {
            let class_grade = this.props.cases?.class_grade_id !== undefined ? this.props.cases?.class_grade_id : this.props.match?.params?.class_grade_id;
            const schoolId = this.props.cases?.school_id || this.props.schoolId;
            const courseId = this.props.cases?.course_id || this.props.match?.params?.course_id;
            if (courseId && class_grade && schoolId) {
                this.fetchKdUnit(courseId, class_grade, schoolId);
            }
        }
    }

    componentDidUpdate(prevProps) {
        // If parent passed new listKd prop:
        if (this.props.listKd && this.props.listKd !== prevProps.listKd) {
            this.setState({ kdUnit: this.props.listKd, isLoadingKD: false });
            this.initializeKompetensiDasar(this.props.listKd);
            return;
        }

        // Only trigger fetch if course or grade level actually changed:
        const currentCourse = this.props.cases?.course_id || this.props.match?.params?.course_id;
        const prevCourse = prevProps.cases?.course_id || prevProps.match?.params?.course_id;
        const currentGrade = this.props.cases?.class_grade_id;
        const prevGrade = prevProps.cases?.class_grade_id;

        if (
            (currentCourse && prevCourse !== currentCourse) ||
            (currentGrade && prevGrade !== currentGrade)
        ) {
            const schoolId = this.props.cases?.school_id || this.props.schoolId;
            if (currentCourse && currentGrade && schoolId) {
                this.fetchKdUnit(currentCourse, currentGrade, schoolId);
            }
        }
    }

    initializeKompetensiDasar(data) {
        const listKD = data || this.state.kdUnit || [];
        const mappedKD = listKD.map((item) => ({
            kompetensi_dasar_id: item.kompetensi_dasar_detail_id || item.kompetensi_dasar_id, // depends on backend format
            description: item.description,
            unit_details: item.unit_details || []
        }));

        this.setState({ kompetensiDasarOptions: mappedKD });
    }

    handleKompetensiDasarChange = (event, idIndexToMap, idQuestion) => {
        const selectedKompetensiDasarId = event.target.value;
        const selectedKompetensiDasarText = event.target.options[event.target.selectedIndex].text;

        this.props.inputKdUnit(
            this.props.indexCasePart,
            idIndexToMap,
            selectedKompetensiDasarId,
            selectedKompetensiDasarText,
            null,
            null,
            null
        );
    };

    handleKompetensiDasarUnitChange = (event, keyPart, idIndexToMap, idQuestion, currentKdId) => {
        const selectedKompetensiDasarUnitId = event.target.value;
        const selectedKompetensiDasarUnitText = event.target.options[event.target.selectedIndex].text;

        const kdInfo = this.state.kompetensiDasarOptions.find((item) => String(item.kompetensi_dasar_id) === String(currentKdId));
        const kdDescription = kdInfo ? kdInfo.description : '';
        const unitDetails = kdInfo ? kdInfo.unit_details : [];
        const unitItem = unitDetails.find(i => String(i.kompetensi_dasar_detail_id || i.unit_detail_id) === String(selectedKompetensiDasarUnitId));
        const unitDesc = (unitItem?.long_description && unitItem.long_description !== '-') ? unitItem.long_description : (unitItem?.description || unitItem?.short_description || null);
        const unitString = unitItem?.unit || null;

        // Pass data to parent component
        this.props.inputKdUnit(
            keyPart,
            idIndexToMap,
            currentKdId,
            kdDescription,
            selectedKompetensiDasarUnitId,
            unitDesc,
            unitString
        );
    };

    render() {
        return (
            <div>
                {this.props.member.case_questions.map((item, index) => (
                    <div key={index + 1} className="card-question">
                        {
                            // dropdown KD
                            !this.state.isLoadingKD && this.state.kdUnit ? (
                                <>
                                    <div>
                                        Capaian Pembelajaran {this.state.kompetensiDasarOptions.length === 0 ? '(Opsional)' : <span className="text-danger">* (Wajib)</span>}: <br></br>
                                        <select
                                            className={`custom-select custom-select-kd mr-sm-2 darkLine my-2 ${this.props.stillEmpty && this.state.kompetensiDasarOptions.length > 0 && !item.kd_id ? 'border-danger' : ''}`}
                                            id={"chooseKD" + (item.id || item.key)}
                                            onChange={(e) => this.handleKompetensiDasarChange(e, index, item.id || item.key)}
                                            value={item.kd_id || ''}
                                        >
                                            <option value="">Pilih Capaian Pembelajaran</option>
                                            {this.state.kompetensiDasarOptions.map((kd) => (
                                                <option key={kd.kompetensi_dasar_id} value={kd.kompetensi_dasar_id}>
                                                    {kd.description || `CP Tanpa Deskripsi`}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        {/* Second Dropdown: Unit Details */}
                                        Tujuan Pembelajaran (TP) {this.state.kompetensiDasarOptions.length === 0 ? '(Opsional)' : (this.props.tipePenilaian === 'TP' ? <span className="text-danger">* (Wajib)</span> : '(Opsional)')}: <br></br>
                                        <select
                                            className={`custom-select custom-select-kd-unit mr-sm-2 darkLine my-2 ${this.props.stillEmpty && this.state.kompetensiDasarOptions.length > 0 && this.props.tipePenilaian === 'TP' && !item.kd_unit_id ? 'border-danger' : ''}`}
                                            id={"chooseKDUnit" + (item.id || item.key)}
                                            onChange={(e) => this.handleKompetensiDasarUnitChange(e, this.props.indexCasePart, index, item.id || item.key, item.kd_id)}
                                            value={item.kd_unit_id || ''}
                                        >
                                            <option value="">Pilih Tujuan Pembelajaran (TP)</option>
                                            {((this.state.kompetensiDasarOptions.find(opt => String(opt.kompetensi_dasar_id) === String(item.kd_id))?.unit_details) || []).map((unit) => (
                                                <option key={unit.kompetensi_dasar_detail_id || unit.unit_detail_id} value={unit.kompetensi_dasar_detail_id || unit.unit_detail_id}>
                                                    {unit.unit}{unit.indikator != null ? `.${unit.indikator}` : ''} - {unit.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <p className="mt-2 mb-5">{item.kd_unit_description || ''}</p>
                                </>
                            ) : (
                                <div className="text-center">
                                    <img src={Ball} alt=""></img>
                                </div>
                            )
                        }

                        <div className="row mb-3">
                            <div className={`col-md-auto align-self-start pt-1 ${this.props.stillEmpty && (item.question === null || item.question === "") ? "bg-danger" : ""}`}>
                                <h3 className="text-right ">{index + 1}.</h3>
                            </div>

                            <div className="col-md-9">
                                {this.state.hidden ? (
                                    ""
                                ) : (
                                    <CKEditor
                                        id={"questionInput" + this.props.indexCasePart + item.key}
                                        editor={ClassicEditor}
                                        data={item.question === null ? "" : item.question}
                                        config={config1}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.handleUpdateQuestion(this.props.indexCasePart, item.key, this.props.member.case_questions, data);
                                        }}
                                        required
                                    />
                                )}

                                <div>
                                    <input className="form-control form-group border-top" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px" }} value={item.video_embed === null ? "" : item.video_embed} onChange={(e) => this.handleUpdateVideoEmbed(this.props.indexCasePart, item.key, this.props.member.case_questions, e.target.value)} placeholder="Video URL (YouTube, Google Drive, dll)" />
                                </div>
                                {item.video_embed && item.video_embed.trim() !== '' && (
                                    <div className="video-preview mt-2 mb-2">
                                        <iframe
                                            width="100%"
                                            height="315"
                                            src={this.convertToEmbedUrl(item.video_embed)}
                                            title="Video Preview"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            style={{ borderRadius: '8px', border: '1px solid #ddd' }}
                                        ></iframe>
                                    </div>
                                )}

                                {item.status_img === 1 ? (
                                    <div className="d-flex align-items-start m-3">
                                        <div className="box-imageQuestionPreview ">
                                            <Zoom isZoomed={true}>
                                                <div className="imageQuestionPreview">
                                                    {item.file_attached === null || item.file_attached === "Loading" ? (
                                                        <div>
                                                            <span>Preview Gambar</span>
                                                        </div>
                                                    ) : (
                                                        <img src={baseImgURL + item.file_attached} alt="" id="my-canvas" />
                                                    )}
                                                </div>
                                            </Zoom>
                                        </div>

                                        <div className="imgUploader ml-3">
                                            <ImageUploader className="imgUploader d-inline" withIcon={true} singleImage={true} withPreview={true} buttonText="Pilih Gambar" onChange={(pictureFiles, pictureDataURLs) => this.onDrop(pictureFiles, pictureDataURLs, this.props.indexCasePart, index)} imgExtension={[".jpg", ".jpeg", ".png"]} maxFileSize={2242880} fileSizeError="Ukuran File Terlalu Besar" label="Ukuran Maks: 2mb dengan format file .jpeg/.jpg/.png" />
                                            <button className="btn btn-gradient-danger btn-sm mr-1" onClick={(e) => this.handleDeleteImage(e, item.file_attached, this.props.indexCasePart, index)}>
                                                Hapus Gambar
                                            </button>
                                            <button className="btn btn-gradient-primary btn-sm" onClick={(e) => this.handleUploadImg(e, this.props.indexCasePart, index, item.file_attached, item.img_file)} disabled={item.img_file === null || item.img_file === undefined ? true : false}>
                                                {item.file_attached === "Loading" ? (
                                                    <div>
                                                        <i className="mdi mdi-loading mdi-spin"></i> Upload Gambar{" "}
                                                    </div>
                                                ) : (
                                                    "Upload Gambar"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {this.props.doingEditCase === true ? (
                                <div className="col-md-auto">
                                    <IconButton onClick={() => this.handleIconAddImg(this.props.indexCasePart, index)}>
                                        <ImageIcon />
                                    </IconButton>
                                    {index !== 0 && (
                                        <IconButton onClick={() => {
                                            this.props.deleteQuestion(this.props.indexCasePart, index)
                                            this.handleResetQuestion(item.id || item.key)
                                        }}>
                                            <RemoveIcon />
                                        </IconButton>
                                    )}
                                    {this.props.typeCase === "uraian" ? (
                                        <IconButton onClick={() => {
                                            this.props.addQuestionEssay(this.props.indexCasePart, index, item);
                                        }}>
                                            <AddIcon />
                                        </IconButton>
                                    ) : this.props.typeCase === "pilihan ganda benar salah" ? (
                                        <IconButton onClick={() => {
                                            this.props.addQuestionTrueFalse(this.props.indexCasePart, index, this.props.member.type_name, item)
                                        }}>
                                            <AddIcon />
                                        </IconButton>
                                    ) : this.props.typeCase === "menjodohkan" ? (
                                        <IconButton onClick={() => {
                                            this.props.addQuestionMenjodohkan(this.props.indexCasePart, index, this.props.member.type_name, item)
                                        }}>
                                            <AddIcon />
                                        </IconButton>
                                    ) : (
                                        <IconButton onClick={() => {
                                            this.props.addQuestion(this.props.indexCasePart, index, this.props.member.type_name, item)
                                        }}>
                                            <AddIcon />
                                        </IconButton>
                                    )}
                                </div>
                            ) : null}
                        </div>
                        {this.props.typeCase === "pilihan ganda" ? ( // jika bukan uraian
                            <TestChoices stillEmpty={this.props.stillEmpty} member={item.case_choices} xPart={this.props.indexCasePart} xQues={index} />
                        ) : this.props.typeCase === "pilihan ganda kompleks" ? (
                            <TestChoicesMultiple stillEmpty={this.props.stillEmpty} member={item.case_choices} xPart={this.props.indexCasePart} xQues={index} />
                        ) : this.props.typeCase === "menjodohkan" ? (
                            <TestChoicesMenjodohkan member={item.case_choices} item={item} stillEmpty={this.props.stillEmpty} xPart={this.props.indexCasePart} xQues={index} indexQuest={item.id} />
                        ) : this.props.typeCase === "isian singkat" ? (
                            <TestShortAnswer member={item.case_choices} xPart={this.props.indexCasePart} xQues={index} />
                        ) : this.props.typeCase === "pilihan ganda benar salah" ? (
                            <TestChoicesTrueFalse stillEmpty={this.props.stillEmpty} member={item.case_choices} xPart={this.props.indexCasePart} xQues={index} />
                        ) : (
                            ""
                        )}
                        <br></br>
                    </div>
                ))}
            </div>
        );
    }
}
const mapToStateToProps = (state) => {
    return {
        doingEditCase: state.Exam.doingEditCase,
        case_part: state.Exam.case_part,
        cases: state.Exam.cases,
        schoolId: state.User.dataSchool?.value,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        inputQuestion: (xPart, xQues, newValue) => dispatch(inputQuestion(xPart, xQues, newValue)),
        inputVideoEmbed: (xPart, xQues, newValue) => dispatch(inputVideoEmbed(xPart, xQues, newValue)),
        addQuestion: (index, indexQues, typeCase, item) => dispatch(addQuestion(index, indexQues, typeCase, item)),
        deleteQuestion: (index, indexQues) => dispatch(deleteQuestion(index, indexQues)),
        addQuestionEssay: (index, indexQues, item) => dispatch(addQuestionEssay(index, indexQues, item)),
        addQuestionTrueFalse: (index, indexQues, typeCase, item) => dispatch(addQuestionTrueFalse(index, indexQues, typeCase, item)),
        addQuestionMenjodohkan: (index, indexQues, typeCase, item) => dispatch(addQuestionMenjodohkan(index, indexQues, typeCase, item)),
        addToListImg: (imageName) => dispatch(addToListImg(imageName)),
        addImageQues: (index, indexQues, image) => dispatch(addImageQues(index, indexQues, image)),
        removeImage: (index, indexQues) => dispatch(removeImage(index, indexQues)),
        addImageFileQues: (index, indexQues, imageFile) => dispatch(addImageFileQues(index, indexQues, imageFile)),
        inputKdUnit: (index, indexQues, kdId, kdDescription, kdUnitId, kdUnitDescription, kdUnitString) => dispatch(inputKdUnit(index, indexQues, kdId, kdDescription, kdUnitId, kdUnitDescription, kdUnitString)),
    };
};
export default connect(mapToStateToProps, mapDispatchToProps)(withRouter(Question));
